import request from 'services/request'
import { bigdataUrl } from '../config'
import Cookies from 'js-cookie'
import { ts as timestamp } from 'utils/date'

export class Bigdata {
  protected cert = ''
  protected requestConfig(): any {
    return {
      baseURL: bigdataUrl,
      headers: {
        timestamp: String(new Date().getTime()),
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        'Access-Control-Allow-Methods': 'POST, GET, OPTIONS',
      },
      timeout: 30000,
      withCredentials: false,
      xsrfCookieName: 'XSRF-TOKEN',
      xsrfHeaderName: 'X-XSRF-TOKEN',
      maxRedirects: 5,
      maxContentLength: 2000,
      validateStatus(status: number) {
        return status >= 200 && status < 500
      },
    }
  }
  private _ts = timestamp()
  private _c = ''
  private __tk = ''
  private _s = ''
  private _a = ''
  private _t = ''
  private _cid = ''
  private _uid = ''
  private _position = ''
  private _referer = ''
  private _delay = -1
  private _ext = ''

  public c(v: string) {
    this._c = v
    return this
  }

  public s(v: string) {
    this._s = v
    return this
  }

  public a(v: string) {
    this._a = v
    return this
  }

  public t(v: string) {
    this._t = v
    return this
  }

  public uid(v: string) {
    this._uid = v
    return this
  }

  public position(v: string) {
    this._position = v
    return this
  }

  public referer(v: string) {
    this._referer = v
    return this
  }

  public delay(v: number) {
    this._delay = v
    return this
  }

  public ext(v: object) {
    this._ext = JSON.stringify(v)
    return this
  }

  public log(): void {
    const _tk = Cookies.get('ltk') || ''
    const cid = Cookies.get('cid') || ''
    const _ts = timestamp()
    if (_tk === '') {
      console.log('tk error')
      return
    }
    if (cid === '') {
      console.log('cid error')
      return
    }

    const m = {
      s: this._s,
      a: this._a,
      t: this._t,
      cid,
      uid: this._uid,
      ts: _ts,
      referer: this._referer,
      position: this._position,
      delay: this._delay,
      ext: this._ext,
    }
    request
      .post('/log', { c: this._c, _tk, m }, this.requestConfig())
      .then((res: any) => {
        if (res.code !== 200) {
          console.log('log error')
          return
        }
      })
      .catch(e => {
        console.log(e)
      })
  }

  public requisite(): void {
    this.requestConfig()
    const current_ts = timestamp()
    request
      .get('/requisite?ts=' + current_ts.toString(), this.requestConfig())
      .then((result: any) => {
        if (result.code !== 200) {
          console.log('requisite error!')
          return
        }
        // @ts-ignore
        this.cert = Yeeha().k(result.data)
        const _cid = Cookies.get('cid') || ''
        request
          .post('/grant', { cert: this.cert, cid: _cid, uid: '', ts: current_ts }, this.requestConfig())
          .then((res2: any) => {
            if (res2.code !== 200) {
              console.log('grant error!')
              return
            }
            const _tk = res2.data
            Cookies.set('ltk', _tk)
          })
          .catch(e => {
            console.log(e)
          })
      })
      .catch(e => {
        console.log(e)
      })
  }
}

export default Bigdata
